import React from "react";
import { useLocation, useParams } from "react-router";
import { toast } from "react-toastify";
import { StartEmailConversation } from "./StartEmailConversation";

export default function StartEmailConversationFromRoute() {
  let { subject, email } = useParams();

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const embed = Boolean(params.get("embed"));

  if (!subject || !email) {
    toast.error("Invalid URL");
    return (window.location.href = "/404");
  }
  return (
    <StartEmailConversation
      subject={decodeURIComponent(subject)}
      recipientEmail={decodeURIComponent(email)}
      triggeredByChildren={false}
      embed={embed}
    />
  );
}
